export const ROLE_CODE_ADMIN = 'admin';
export const ROLE_CODE_ADMIN_BASIC = 'admin_basic';
export const ROLE_CODE_GROUP_MANAGER = 'group_manager';
export const ROLE_CODE_CREATIVE_SPECIALIST = 'creative_specialist';
export const ROLE_CODE_INTEGRATION_SPECIALIST = 'integration_specialist';
export const ROLE_CODE_EVENT_ORGANIZER = 'event_organizer';
export const ROLE_CODE_ONSITE_SPECIALIST = 'onsite_specialist';
export const ROLE_CODE_READ_ONLY = 'read_only';

export const ROLE_ADMIN = 'Admin';
export const ROLE_GROUP_MANAGER = 'Group Manager';
export const ROLE_CREATIVE_SPECIALIST = 'Creative Specialist';
export const ROLE_INTEGRATION_SPECIALIST = 'Integrations Specialist';
export const ROLE_ADMIN_BASIC = 'Admin (Basic)';
export const ROLE_EVENT_ORGANIZER = 'Event Organizer';
export const ROLE_ONSITE_SPECIALIST = 'On-site Specialist';
export const ROLE_READ_ONLY = 'Viewer (Read-only)';
